// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/firstparty/v4/create_payment_link.proto

/* oxlint-disable */
import { ApiCurrencyAmount } from "../../../../common/payment";
import {
  ApiItemType,
  apiItemTypeFromJSON,
  apiItemTypeToJSON,
  ApiPaymentLink,
  ApiPaymentLinkSettings,
  ApiRecurrenceSettings,
  ApiResourceType,
  apiResourceTypeFromJSON,
  apiResourceTypeToJSON,
} from "./payment_link";
import { ApiPaymentMethod, apiPaymentMethodFromJSON, apiPaymentMethodToJSON } from "./payment_method";

/** Payment initiator data for creation */
export interface ApiPaymentInitiatorCreate {
  /** Resource type */
  readonly resourceType: ApiResourceType;
  /** Resource number (can be null) */
  readonly resourceNumber?:
    | string
    | null
    | undefined;
  /** Resource ID (can be null, required if resource_type is Invoice) */
  readonly resourceId?: string | null | undefined;
}

/** Payment link item data for creation */
export interface ApiPaymentLinkItemCreate {
  /** Item title */
  readonly title: string;
  /** Item type (can be null) */
  readonly type?:
    | ApiItemType
    | null
    | undefined;
  /** Item description (can be null) */
  readonly description?:
    | string
    | null
    | undefined;
  /** Item quantity */
  readonly quantity: number;
  /** Measurement unit (can be null) */
  readonly measureUnit?:
    | string
    | null
    | undefined;
  /** Unit price */
  readonly unitPrice:
    | ApiCurrencyAmount
    | null;
  /** VAT rate */
  readonly vatRate: string;
}

/** Request to create a payment link */
export interface ApiCreatePaymentLinkRequest {
  /** Payment amount */
  readonly amount:
    | ApiCurrencyAmount
    | null;
  /** Debitor name (can be null, required if resource_type is Invoice) */
  readonly debitorName?:
    | string
    | null
    | undefined;
  /** Payment initiator information */
  readonly paymentInitiator:
    | ApiPaymentInitiatorCreate
    | null;
  /** List of potential payment methods (at least one required) */
  readonly potentialPaymentMethods: readonly ApiPaymentMethod[];
  /** Payment link settings (can be null) */
  readonly settings?:
    | ApiPaymentLinkSettings
    | null
    | undefined;
  /** Organization name (can be null) */
  readonly organizationName?:
    | string
    | null
    | undefined;
  /** Items in the basket (can be null, required if resource_type is Basket) */
  readonly items: readonly ApiPaymentLinkItemCreate[];
  /** Recurrency settings (can be nullable if not a recurrent payment link) */
  readonly recurrenceSettings?: ApiRecurrenceSettings | null | undefined;
}

/** Response when a payment link is successfully created */
export interface ApiCreatePaymentLinkResponse {
  /** The created payment link */
  readonly paymentLink: ApiPaymentLink | null;
}

export const ApiPaymentInitiatorCreate: MessageFns<ApiPaymentInitiatorCreate> = {
  fromJSON(object: any): ApiPaymentInitiatorCreate {
    return {
      resourceType: isSet(object.resource_type)
        ? apiResourceTypeFromJSON(object.resource_type)
        : ApiResourceType.RESOURCE_TYPE_UNSPECIFIED,
      resourceNumber: isSet(object.resource_number) ? globalThis.String(object.resource_number) : null,
      resourceId: isSet(object.resource_id) ? globalThis.String(object.resource_id) : null,
    };
  },

  toJSON(message: ApiPaymentInitiatorCreate): unknown {
    const obj: any = {};
    if (message.resourceType !== undefined && message.resourceType !== null) {
      obj.resource_type = apiResourceTypeToJSON(message.resourceType);
    }
    if (message.resourceNumber !== undefined && message.resourceNumber !== null) {
      obj.resource_number = message.resourceNumber;
    }
    if (message.resourceId !== undefined && message.resourceId !== null) {
      obj.resource_id = message.resourceId;
    }
    return obj;
  },
};

export const ApiPaymentLinkItemCreate: MessageFns<ApiPaymentLinkItemCreate> = {
  fromJSON(object: any): ApiPaymentLinkItemCreate {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      type: isSet(object.type) ? apiItemTypeFromJSON(object.type) : null,
      description: isSet(object.description) ? globalThis.String(object.description) : null,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      measureUnit: isSet(object.measure_unit) ? globalThis.String(object.measure_unit) : null,
      unitPrice: isSet(object.unit_price) ? ApiCurrencyAmount.fromJSON(object.unit_price) : null,
      vatRate: isSet(object.vat_rate) ? globalThis.String(object.vat_rate) : "",
    };
  },

  toJSON(message: ApiPaymentLinkItemCreate): unknown {
    const obj: any = {};
    if (message.title !== undefined && message.title !== null) {
      obj.title = message.title;
    }
    if (message.type !== undefined && message.type !== null) {
      obj.type = apiItemTypeToJSON(message.type);
    }
    if (message.description !== undefined && message.description !== null) {
      obj.description = message.description;
    }
    if (message.quantity !== undefined && message.quantity !== null) {
      obj.quantity = message.quantity;
    }
    if (message.measureUnit !== undefined && message.measureUnit !== null) {
      obj.measure_unit = message.measureUnit;
    }
    if (message.unitPrice !== undefined && message.unitPrice !== null) {
      obj.unit_price = ApiCurrencyAmount.toJSON(message.unitPrice);
    }
    if (message.vatRate !== undefined && message.vatRate !== null) {
      obj.vat_rate = message.vatRate;
    }
    return obj;
  },
};

export const ApiCreatePaymentLinkRequest: MessageFns<ApiCreatePaymentLinkRequest> = {
  fromJSON(object: any): ApiCreatePaymentLinkRequest {
    return {
      amount: isSet(object.amount) ? ApiCurrencyAmount.fromJSON(object.amount) : null,
      debitorName: isSet(object.debitor_name) ? globalThis.String(object.debitor_name) : null,
      paymentInitiator: isSet(object.payment_initiator)
        ? ApiPaymentInitiatorCreate.fromJSON(object.payment_initiator)
        : null,
      potentialPaymentMethods: globalThis.Array.isArray(object?.potential_payment_methods)
        ? object.potential_payment_methods.map((e: any) => apiPaymentMethodFromJSON(e))
        : [],
      settings: isSet(object.settings) ? ApiPaymentLinkSettings.fromJSON(object.settings) : null,
      organizationName: isSet(object.organization_name) ? globalThis.String(object.organization_name) : null,
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ApiPaymentLinkItemCreate.fromJSON(e))
        : [],
      recurrenceSettings: isSet(object.recurrence_settings)
        ? ApiRecurrenceSettings.fromJSON(object.recurrence_settings)
        : null,
    };
  },

  toJSON(message: ApiCreatePaymentLinkRequest): unknown {
    const obj: any = {};
    if (message.amount !== undefined && message.amount !== null) {
      obj.amount = ApiCurrencyAmount.toJSON(message.amount);
    }
    if (message.debitorName !== undefined && message.debitorName !== null) {
      obj.debitor_name = message.debitorName;
    }
    if (message.paymentInitiator !== undefined && message.paymentInitiator !== null) {
      obj.payment_initiator = ApiPaymentInitiatorCreate.toJSON(message.paymentInitiator);
    }
    if (message.potentialPaymentMethods?.length) {
      obj.potential_payment_methods = message.potentialPaymentMethods.map((e) => apiPaymentMethodToJSON(e));
    }
    if (message.settings !== undefined && message.settings !== null) {
      obj.settings = ApiPaymentLinkSettings.toJSON(message.settings);
    }
    if (message.organizationName !== undefined && message.organizationName !== null) {
      obj.organization_name = message.organizationName;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => ApiPaymentLinkItemCreate.toJSON(e));
    }
    if (message.recurrenceSettings !== undefined && message.recurrenceSettings !== null) {
      obj.recurrence_settings = ApiRecurrenceSettings.toJSON(message.recurrenceSettings);
    }
    return obj;
  },
};

export const ApiCreatePaymentLinkResponse: MessageFns<ApiCreatePaymentLinkResponse> = {
  fromJSON(object: any): ApiCreatePaymentLinkResponse {
    return { paymentLink: isSet(object.payment_link) ? ApiPaymentLink.fromJSON(object.payment_link) : null };
  },

  toJSON(message: ApiCreatePaymentLinkResponse): unknown {
    const obj: any = {};
    if (message.paymentLink !== undefined && message.paymentLink !== null) {
      obj.payment_link = ApiPaymentLink.toJSON(message.paymentLink);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
